import isSimpleObject from "./isSimpleObject";

/**
 * Walks the properties on target or items in an array, and run onEach on each. This is deep (not shallow) traversal of properties.
 * This will traverse own and enumerable properties of simple objects (i.e. objects with prototype equal to that of Object or null).
 * Your onEach should always return a value no matter if changed or not. ALl values, including `null` and `undefined` will be
 * used as the new value for the property.
 * The onEach is called on the root target as well with the "key" set to `undefined`. A return value of `undefined or `null`
 * for the root target will be ignored.
 * If you want your onEach to be from deepest to most shallow, set `tailCall` to true.
 */
export default function deepForEach<O extends object>(
	target: O,
	onEach: (value: any | null | undefined, key: string | undefined) => O | null | undefined,
	tailCall = false
): O {

	if (!tailCall) {
		const tmpTarget = onEach(target, undefined);
		if (target !== undefined && target !== null) {
			target = tmpTarget!;
		}
	}

	const propNames = Object.keys(target);
	propNames.forEach(key => {
		let value = (target as any)[key];
		if (!tailCall) {
			value = onEach(value, key);
		}
		if (
			value !== undefined && value !== null
			&& (Array.isArray(value) || isSimpleObject(value))
		) {
			value = deepForEach(value, onEach, tailCall);
		}
		if (tailCall) {
			value = onEach(value, key);
		}
		(target as any)[key] = value;
	});

	if (tailCall) {
		const tmpTarget = onEach(target, undefined);
		if (target !== undefined && target !== null) {
			target = tmpTarget!;
		}
	}

	return target;
}


(window as any).deepForEach = deepForEach; // TODO Delete this.